import React from "react";
import "./timeline.css";

const TimelineContainer = ({ children }) => {
  return <div className={"timeline-container"}>{children}</div>;
};

export default TimelineContainer;
